import { render, staticRenderFns } from "./pack.vue?vue&type=template&id=b141b4dc&scoped=true&"
import script from "./pack.vue?vue&type=script&lang=js&"
export * from "./pack.vue?vue&type=script&lang=js&"
import style0 from "./pack.vue?vue&type=style&index=0&id=b141b4dc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b141b4dc",
  null
  
)

export default component.exports